import React from "react";
import "../App.css";

export default function TermsOfServicePage() {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "5px", color: "#1f2937" }}>
        Syarat & Ketentuan
      </h1>
      <p style={{ fontSize: "0.9rem", color: "#6b7280", marginBottom: "20px" }}>
        Terakhir diperbarui: 12 November 2025
      </p>

      <p style={paragraphStyle}>
        Selamat datang di <strong>MySite</strong>, layanan milik <strong>PT. Karya Digital Indo</strong>.
        Dokumen Syarat & Ketentuan (“Ketentuan”) ini mengatur penggunaan Anda atas platform
        <strong> pembuatan dan hosting landing page</strong> kami (“Layanan”). Dengan menggunakan
        MySite, Anda menyetujui Ketentuan ini sepenuhnya.
      </p>

      <h2 style={sectionTitleStyle}>1. Akun dan Tanggung Jawab Pengguna</h2>
      <p style={paragraphStyle}>
        Anda bertanggung jawab menjaga kerahasiaan kredensial akun Anda. Segala aktivitas
        yang terjadi melalui akun Anda menjadi tanggung jawab Anda. Anda wajib memastikan
        informasi yang diberikan (seperti nama dan email) adalah akurat dan selalu diperbarui.
      </p>

      <h2 style={sectionTitleStyle}>2. Penggunaan Layanan</h2>
      <p style={paragraphStyle}>
        MySite menyediakan alat untuk membuat dan menghosting landing page. Anda setuju untuk
        tidak menggunakan Layanan untuk aktivitas ilegal, melanggar hak pihak lain, menyebarkan
        malware, konten menyesatkan, atau pelanggaran hukum/peraturan yang berlaku. Kami berhak
        menolak, menghapus, atau menonaktifkan konten yang melanggar Ketentuan ini.
      </p>

      <h2 style={sectionTitleStyle}>3. Konten Pengguna & Kepemilikan</h2>
      <p style={paragraphStyle}>
        Konten yang Anda unggah (teks, gambar, aset desain) tetap menjadi milik Anda. Dengan
        mengunggah ke MySite, Anda memberikan lisensi non-eksklusif untuk menyimpan, menampilkan,
        dan memproses konten tersebut semata-mata untuk menyelenggarakan Layanan. Anda bertanggung
        jawab untuk memastikan konten tidak melanggar hak cipta, merek dagang, privasi, ataupun
        hukum yang berlaku.
      </p>

      <h2 style={sectionTitleStyle}>4. Paket, Pembayaran & Pengembalian Dana</h2>
      <p style={paragraphStyle}>
        Layanan beroperasi dengan paket berlangganan sesuai yang Anda pilih. Biaya
        berlangganan dibayarkan di muka dan <strong>tidak dapat dikembalikan</strong> kecuali diwajibkan oleh
        hukum. Harga dan fitur dapat berubah sewaktu-waktu; perubahan akan berlaku pada periode
        berlangganan berikutnya dan akan kami informasikan terlebih dahulu.
      </p>

      <h2 style={sectionTitleStyle}>5. Ketersediaan Layanan & Batasan</h2>
      <p style={paragraphStyle}>
        Kami berupaya menjaga Layanan tetap tersedia dan andal. Namun, Layanan dapat terdampak
        pemeliharaan, pembaruan, gangguan jaringan, atau faktor di luar kendali kami. PT. Karya
        Digital Indo tidak bertanggung jawab atas kehilangan data, keterlambatan, atau kerugian
        tidak langsung akibat gangguan layanan.
      </p>

      <h2 style={sectionTitleStyle}>6. Privasi & Perlindungan Data</h2>
      <p style={paragraphStyle}>
        Kami memproses data pribadi Anda sesuai dengan Kebijakan Privasi MySite. Dengan
        menggunakan Layanan, Anda menyetujui praktik pengumpulan dan penggunaan data seperti
        dijelaskan dalam kebijakan tersebut.
      </p>

      <h2 style={sectionTitleStyle}>7. Kepatuhan Hukum & Larangan</h2>
      <p style={paragraphStyle}>
        Anda setuju untuk mematuhi hukum yang berlaku. Dilarang menggunakan Layanan untuk
        konten yang melanggar hukum, diskriminatif, pornografi ilegal, peretasan, maupun
        aktivitas merugikan lainnya. Pelanggaran dapat mengakibatkan penangguhan atau penghentian akun.
      </p>

      <h2 style={sectionTitleStyle}>8. Penangguhan & Penghentian</h2>
      <p style={paragraphStyle}>
        Kami dapat menangguhkan atau menghentikan akses Anda ke Layanan tanpa pemberitahuan
        sebelumnya apabila Anda: (a) melanggar Ketentuan ini, (b) melakukan kecurangan atau
        penyalahgunaan, atau (c) menimbulkan risiko hukum/operasional bagi MySite. Anda dapat
        menghentikan penggunaan kapan saja, namun biaya yang telah dibayarkan tidak dikembalikan.
      </p>

      <h2 style={sectionTitleStyle}>9. Penyangkalan & Batas Tanggung Jawab</h2>
      <p style={paragraphStyle}>
        Layanan disediakan “apa adanya” tanpa jaminan tersurat/tersirat mengenai ketersediaan,
        kesesuaian untuk tujuan tertentu, atau non-pelanggaran. Sejauh diizinkan hukum, PT. Karya
        Digital Indo tidak bertanggung jawab atas kerugian tidak langsung, insidental, khusus, atau
        konsekuensial yang timbul dari penggunaan atau ketidakmampuan menggunakan Layanan.
      </p>

      <h2 style={sectionTitleStyle}>10. Perubahan Ketentuan</h2>
      <p style={paragraphStyle}>
        Kami dapat memperbarui Ketentuan ini dari waktu ke waktu. Pembaruan penting akan kami
        sampaikan melalui halaman ini atau notifikasi lain yang layak. Dengan terus menggunakan
        Layanan setelah perubahan, Anda dianggap menyetujui Ketentuan yang diperbarui.
      </p>

      <h2 style={sectionTitleStyle}>11. Kontak</h2>
      <p style={paragraphStyle}>
        Untuk pertanyaan terkait Ketentuan ini, hubungi kami di <strong>support@mysite.co.id</strong>.
      </p>
    </div>
  );
}

const paragraphStyle = {
  fontSize: "1rem",
  color: "#4b5563",
  marginBottom: "20px",
  lineHeight: "1.6",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  fontWeight: "600",
  marginBottom: "10px",
  color: "#1f2937",
};

const listStyle = {
  marginLeft: "20px",
  color: "#4b5563",
  fontSize: "1rem",
  lineHeight: "1.6",
  marginBottom: "20px",
};
